/**
 * Zugriff auf localStorage, der nie eine Ausnahme wirft.
 *
 * Safari ist hier strenger als die anderen Browser. Steht "Alle Cookies
 * blockieren" an oder laeuft ein privates Fenster, wirft schon das blosse
 * Lesen einen SecurityError - und das Schreiben quittiert Safari im privaten
 * Modus mit QuotaExceededError, obwohl reichlich Platz da waere.
 *
 * Direkt im Code sah das so aus:
 *
 *     const [collapsed, setCollapsed] = useState(
 *       () => localStorage.getItem("sidebar_collapsed") === "true");
 *
 * Eine Ausnahme an dieser Stelle laesst die Komponente nie fertig rendern.
 * React bricht ab, und uebrig bleibt eine weisse Seite - ohne Meldung, ohne
 * Hinweis, und nur auf dem Geraet mit der strengeren Einstellung.
 *
 * Eine gespeicherte Vorliebe ist das nicht wert. Faellt der Speicher aus,
 * arbeitet die Anwendung mit den Standardwerten weiter; sie merkt sich die
 * Einstellung dann nur bis zum naechsten Laden.
 */

export function lesen(schluessel, ersatz = null) {
  try {
    const wert = window.localStorage.getItem(schluessel);
    return wert === null ? ersatz : wert;
  } catch {
    return ersatz;
  }
}

export function schreiben(schluessel, wert) {
  try {
    window.localStorage.setItem(schluessel, String(wert));
    return true;
  } catch {
    return false;
  }
}

export function entfernen(schluessel) {
  try {
    window.localStorage.removeItem(schluessel);
    return true;
  } catch {
    return false;
  }
}
